export enum DiagramDetailPanelGridButtonId {
    DIAGRAM_ADD_ATTRIBUTE_BUTTON = "DIAGRAM_ADD_ATTRIBUTE_BUTTON",
    DIAGRAM_UPDATE_ATTRIBUTE_BUTTON = "DIAGRAM_UPDATE_ATTRIBUTE_BUTTON",
    DIAGRAM_DELETE_ATTRIBUTE_BUTTON = "DIAGRAM_DELETE_ATTRIBUTE_BUTTON",
}